import { Truck } from 'lucide-react';

/**
 * Single-vehicle tile for the Planning left-panel "Araçlar" tab.
 *
 * Drag a tile onto a planning cell to attach the vehicle's plate to that
 * (route, day) assignment. Drop logic lives in Planning.jsx and uses the
 * `setDraggedVehicle()` state — dataTransfer carries `vehicle:<id>`.
 *
 * Visual is intentionally simple — plate (bold, monospace) + brand/model.
 * `firm_name` (when present) shows as a tiny chip so the operator picks the
 * right truck for the active firm filter.
 */
export function VehicleTile({ vehicle, onDragStart }) {
  const plate = vehicle.license_plate || '—';
  const model = [vehicle.brand, vehicle.model].filter(Boolean).join(' ') || '—';
  return (
    <div
      draggable
      onDragStart={(e) => onDragStart(e, vehicle)}
      className="group flex items-center gap-2 px-2 py-1.5 rounded border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 hover:border-sky-300 hover:bg-sky-50 dark:hover:bg-sky-900/20 cursor-grab active:cursor-grabbing transition-colors"
      data-testid={`vehicle-tile-${vehicle.id}`}
      title={`${plate} · ${model}`}
    >
      <div className="h-7 w-7 rounded bg-slate-100 dark:bg-slate-800 flex items-center justify-center shrink-0">
        <Truck className="h-3.5 w-3.5 text-slate-500" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-xs font-bold font-mono tracking-tight truncate">{plate}</div>
        <div className="text-[10px] text-slate-500 truncate">{model}</div>
      </div>
      {vehicle.firm_name && (
        <span className="text-[9px] px-1 py-0 rounded bg-indigo-100 text-indigo-700 font-semibold uppercase tracking-tight shrink-0">
          {vehicle.firm_name}
        </span>
      )}
    </div>
  );
}
